export const convertCamelCaseToWords = (attribute) => {
    const result = attribute.replace(/([A-Z])/g, " $1");
    return attribute.charAt(0).toUpperCase() + result.slice(1);
}

export const getLength  = (attribute) => {
    if(attribute)
        return attribute.length

    return 0;
}

export const getHostClassOrAsgPrefix = (input, pod) => {
    if(input && pod) {
        let trimmedInput = `${input}-${pod}`;
        while(getLength(trimmedInput) > 29) {
            let inputAsArray = trimmedInput.split('-');
            let trimmedInputArray = inputAsArray.slice(0, inputAsArray.length-2)

            trimmedInput = `${trimmedInputArray.join('-')}-${pod}`
        }
        return trimmedInput;
    }
    return;
}

export const parseCommaSeparatedString = (value: string): string[] => {
    if (!value || value.trim() === '') {
        return [];
    }

    return value.split(',').map(item => item.trim()).filter(item => item !== '');
}

export const formatYesNo = (value: boolean): string => value ? 'Yes' : 'No';

export const isValidUrl = (url: string): boolean => {
    return /^https?:\/\//i.test(url);
};
